import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {Notification} from '../model/notification';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor() {}
  private notifications: BehaviorSubject<Notification[]> = new BehaviorSubject<Notification[]>([]);

  getNotifications () {
    return this.notifications.value;
  }

  implementNotification(note: Notification, delay?: number) {
    const toast = new Notification(note);
    toast.id = new Date().getTime();
    const arr = this.getNotifications();
    arr.push(toast);
    this.notifications.next(arr);
    setTimeout(() => {
      const idx = this.getNotifications().findIndex(v => v.id == toast.id);
      if (idx > -1) {
        this.getNotifications().splice(idx, 1);
      }
    }, delay ?? 50000)
  }
}
